import { createHeroView, createNavigationView } from './index'

const Unsubscribe = () => import('../components/Newsletter/Unsubscribe.vue')

export const routes = () => [
  {
    path: '/leiratkozas/:email',
    components: {
      default: Unsubscribe,
      hero: createHeroView('content-page'),
      navigation: createNavigationView()
    },
    props: {
      default: true
    },
    meta: {
      pageTitle: 'Newsletter unsubscribe'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/newsletter.js